import React from "react"
import { useTranslation } from "react-i18next"
import { Link, useNavigate } from "react-router-dom"
import { TopBarContainer } from "../top-bar-container"
import BackIcon from "@/assets/icons/misc/back-icon.tsx"
import NewPlusIcon from "@/assets/icons/misc/new-plus-icon.tsx"
import commonStyles from "@/common.module.css"
import { useMediaQuery } from "@/hooks/use-media-query.ts"

interface MobileTopBarProps {
  navigateTo?: string
  title: string
  onIconClick?: () => void
  onBackClick?: () => void
  icon?: React.ReactNode
  titleInfo?: React.ReactNode
  rightContent?: React.ReactNode
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({
  title,
  navigateTo,
  onIconClick,
  icon,
  titleInfo,
  onBackClick,
  rightContent,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isDesktop = useMediaQuery("(min-width: 768px)")

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick()
    } else {
      navigate(-1)
    }
  }

  if (isDesktop) return null

  return (
    <TopBarContainer>
      <div className="flex min-w-0 flex-1 items-center">
        <div
          className="grid cursor-pointer place-content-center p-4"
          onClick={handleBackClick}
        >
          <BackIcon />
        </div>
        <div className="overflow-hidden truncate whitespace-nowrap text-body-md font-semibold leading-[30px] text-[var(--dark-grey)]">
          {title}
        </div>
        {titleInfo}
      </div>
      {rightContent && (
        <div className="flex items-center pl-2 pr-2">{rightContent}</div>
      )}
      {onIconClick && icon && (
        <div onClick={onIconClick} className="grid place-content-center p-4">
          {icon}
        </div>
      )}
      {navigateTo && (
        <Link className="grid place-content-center p-4" to={navigateTo}>
          <span className={commonStyles["sr-only"]}>{t("newAnimal")}</span>
          {icon ? icon : <NewPlusIcon />}
        </Link>
      )}
    </TopBarContainer>
  )
}

export default MobileTopBar
